<template>
  <div class="w-full">
    <swiper :options="swiperOption" ref="mySwiper" v-if="journeys">
      <swiper-slide
        v-for="(journey, k) in journeys"
        :key="k"
        class="fixed w-full flex flex-col items-center justify-center px-2"
      >
        <div
          class="w-full bg-white rounded-lg inline-flex flex-col p-2 dark:bg-[#27282a] dark:text-white"
        >
          <div class="w-full mb-4">
            <div
              v-if="!isSameDay(journey.departure.datetime)"
              class="text-center text-slate-900 dark:text-slate-100 text-sm py-2"
            >
              Trajet le
              {{
                new Date(journey.departure.datetime)
                  .toLocaleDateString()
                  .slice(0, 5)
              }}
            </div>
            <div class="flex justify-around w-full">
              <div class="flex flex-col text-center">
                <div class="text-sm text-slate-800 dark:text-slate-50">
                  Départ
                </div>
                <div class="text-slate-900 dark:text-white text-lg font-medium">
                  {{ formatTime(journey.departure.datetime) }}
                </div>
              </div>
              <div class="flex flex-col text-center">
                <div class="text-sm text-slate-800 dark:text-slate-50">
                  Durée
                </div>
                <div
                  class="text-slate-900 dark:text-white text-lg font-semibold"
                >
                  {{ formatDuration(journey.duration) }}
                </div>
              </div>
              <div class="flex flex-col text-center">
                <div class="text-sm text-slate-800 dark:text-slate-50">
                  Arrivée
                </div>
                <div class="text-slate-900 dark:text-white text-lg font-medium">
                  {{ formatTime(journey.arrival.datetime) }}
                </div>
              </div>
            </div>
            <div class="flex justify-around w-full">
              <div class="text-gray-800 font-medium text-sm">
                <!-- TODO -->
              </div>
            </div>
          </div>
          <hr class="w-full pb-2" />
          <div class="w-full mt-1">
            <div class="w-full h-full flex items-center justify-between">
              <div class="inline-flex justify-around">
                <Ligne
                  v-for="(line, kl) in extractLine(journey)"
                  :key="kl"
                  :name="`${line}`"
                  size="small"
                  class="mx-1"
                />
              </div>
              <!-- <div
                class="w-1/3 flex items-center justify-center text-orange-600 font-semibold uppercase border-gray-400 pointer outline-none"
                style="border-width: 0; border-left-width: 1px;"
                @click="openTravel(journey)"
              >
                Go
                <img
                  src="/images/back.svg"
                  style="height: auto; width: 15px;"
                  class="origin-center transform rotate-180 ml-2"
                />
              </div> -->

              <button
                @click="openTravel(journey)"
                class="inline-flex items-center justify-center px-4 py-2 text-base font-medium leading-6 text-gray-600 whitespace-no-wrap bg-slate-100 bg-opacity-50 outline-none border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:shadow-none dark:bg-transparent umami--click--launch-travel"
              >
                <div class="dark:text-white">
                  <svg
                    style="height: auto; width: 15px;"
                    class="origin-center transform rotate-180"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                  </svg>
                </div>
              </button>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import Ligne from "@/components/Ligne.vue";

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "Travels",
  components: {
    Ligne,
    swiper,
    swiperSlide
  },
  props: {
    journeys: Array
  },

  methods: {
    formatTime(datetime) {
      return datetime.split("T")[1].slice(0, 5);
    },
    formatDuration({ hours, minutes }) {
      if (hours > 0) {
        return `${hours}h ${minutes} min`;
      }
      return `${minutes} min`;
    },
    isSameDay(datetime) {
      return datetime.split("T")[0] == new Date().toISOString().split("T")[0];
    },
    extractLine(data) {
      return data.journey.map(j => j.metadata.line).filter(Boolean);
    },
    openTravel(journey) {
      this.$store.commit("openTravel", journey);
    }
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: false,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 50,
          stretch: -100,
          depth: 100,
          modifier: 0.5,
          slideShadows: false
        }
      }
    };
  }
};
</script>
